import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  makeApiCall(endpoint: string): Observable<string> {
    const headers = new HttpHeaders(this.authService.getAuthHeaders());
    return this.http.get(`${environment.apiUrl}${endpoint}`, { 
      headers,
      responseType: 'text'
    });
  }
} 